import dayjsTZ from "../../utils/dayjs";
import { FormGridStatusRenderer } from "./FormGridStatusRenderer/FormGridStatusRenderer";
import UploadedFilesRenderer from "../Documentation/UploadedFilesRenderer/UploadedFilesRenderer";
import { RedWarning } from "../../assets/icons";
import { Tooltip } from "antd";
import { htmlParser } from "../../utils";
import colorShade from "../../utils/colorShade";
import getAgThemePreference from "../../utils/getAgThemePreference";

const DATE_FORMAT = "DD/MM/YYYY";
const { mode, accentColor } = getAgThemePreference();

export const documentationsPageColDef = ({
  accessToken,
  statuses,
  employees,
  navigate,
  isMobileView,
}) => [
  {
    headerName: "Punonjësi",
    field: "name",
    filter: "agTextColumnFilter",
    mobile: true,
    cellClickKey: "recordId",
    isCollapseTitle: true,
    isExported: true,
    valueGetter: ({ data }) => (data?.name ? data.name : ""),
    onCellClick: ({ clickId }) => navigate(`/punonjesit/specifikat/${clickId}`),
    ...(!isMobileView
      ? {
          cellRenderer: ({ data, node }) =>
            node.group ? null : (
              <div
                style={{
                  cursor: "pointer",
                  ...(mode.includes("dark")
                    ? { color: "#FFF" }
                    : { color: colorShade(accentColor, 0.25) }),
                  fontWeight: 600,
                }}
                onClick={() =>
                  navigate(`/punonjesit/specifikat/${data?.recordId}`)
                }
              >
                {data?.name}
              </div>
            ),
        }
      : {}),
  },
  {
    headerName: "Departamenti",
    field: "employeeDepartmentName",
    filter: "agTextColumnFilter",
    mobile: true,
    isExported: true,
    valueGetter: ({ data }) =>
      data?.employeeDepartmentName ? data.employeeDepartmentName : "",
    cellRenderer: ({ value, node }) => (node.group ? null : value),
    // hide: true,
    resizable: true,
    sortable: true,
    // enableRowGroup: false,
  },
  {
    headerName: "Roli",
    field: "employeeRoleName",
    filter: "agTextColumnFilter",
    mobile: true,
    isExported: true,
    valueGetter: ({ data }) =>
      data?.employeeRoleName ? data.employeeRoleName : "",
    cellRenderer: ({ value, node }) => (node.group ? null : value),
    // hide: true,
    resizable: true,
    sortable: true,
    enableRowGroup: true,
  },
  {
    headerName: "Lloji i Dokumentacionit",
    field: "docType",
    mobile: true,
    filter: "agTextColumnFilter",
    cellClickKey: "recordId",
    stateKeys: ["docId"],
    isCollapseTitle: true,
    isExported: true,
    valueGetter: ({ data }) => (data?.docType ? data.docType : ""),
    onCellClick: ({ clickId, states }) =>
      navigate(`/punonjesit/specifikat/${clickId}`, {
        state: {
          tab: "Dokumentacione",
          key: "3",
          openDocModal: states?.[0],
        },
      }),
    ...(!isMobileView
      ? {
          cellRenderer: ({ data, value, node }) =>
            node.group ? null : (
              <div
                style={{
                  cursor: "pointer",
                  ...(mode.includes("dark")
                    ? { color: "#FFF" }
                    : { color: colorShade(accentColor, 0.25) }),
                  fontWeight: 600,
                }}
                onClick={() =>
                  navigate(`/punonjesit/specifikat/${data?.recordId}`, {
                    state: {
                      tab: "Dokumentacione",
                      key: "3",
                      openDocModal: data?.docId,
                    },
                  })
                }
              >
                {value}
              </div>
            ),
        }
      : {}),
    enableRowGroup: true,
    resizable: true,
    sortable: true,
  },
  {
    headerName: "Statusi",
    field: "docStatus",
    mobile: true,
    isExported: true,
    filter: "agTextColumnFilter",
    valueGetter: ({ data }) => (data?.docStatus ? data.docStatus : ""),
    cellRenderer: ({ value, node }) =>
      !node.group
        ? htmlParser(FormGridStatusRenderer({ value, statuses }))
        : null,
    cellClass: "centeredCell",
    resizable: true,
    sortable: true,
    enableRowGroup: true,
  },
  // {
  //   headerName: "Kategoria",
  //   field: "categoryName",
  //   filter: "agTextColumnFilter",
  //   resizable: true,
  //   sortable: true,
  //   enableRowGroup: true,
  //   cellClass: "centeredCell",
  // },
  {
    headerName: "Skedarët e Ngarkuar",
    field: "googleDriveUploads",
    filter: "agTextColumnFilter",
    valueGetter: null,
    cellRenderer: ({ data, node }) =>
      node.group
        ? null
        : UploadedFilesRenderer({
            node: { data: { googleDriveUpload: data?.googleDriveUpload } },
            accessToken,
          }),
    cellClass: "centeredCell",
    resizable: true,
    sortable: true,
    enableRowGroup: false,
  },
  {
    headerName: "Krijuar në",
    field: "createdAt",
    hide: true,
    format: "DD/MM/YYYY",
    valueGetter: ({ data }) =>
      data?.createdAt ? dayjsTZ(data.createdAt).format("DD/MM/YYYY") : "",
    cellRenderer: ({ value, node }) => (node.group ? null : value),
    isExported: true,
  },
  {
    headerName: "Data e Skadencës",
    field: "expirationDate",
    mobile: true,
    isExported: true,
    format: "DD/MM/YYYY",
    filter: "agTextColumnFilter",
    cellClass: "centeredCell",
    valueGetter: ({ data }) =>
      data?.expirationDate
        ? dayjsTZ(data.expirationDate).format("DD/MM/YYYY")
        : "",
    cellRenderer: ({ data, value, node }) => {
      if (node.group) return null;
      if (!value) return value;

      let isExpiring = false;
      const currentTimestamp = parseInt(dayjsTZ().format("x"));
      const expirationTimestamp = dayjsTZ(parseInt(data?.expirationDate));
      if (
        currentTimestamp + 604800000 > expirationTimestamp &&
        expirationTimestamp > currentTimestamp
      ) {
        isExpiring = true;
      }
      return (
        <Tooltip
          placement="top"
          title={`${!!isExpiring ? "Po skadon" : ""}`}
          classNames={{ root: "expirationDateTooltip" }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span>{value}</span>
            {!!isExpiring && <RedWarning />}
          </div>
        </Tooltip>
      );
    },
    resizable: true,
    sortable: true,
    enableRowGroup: true,
  },
];
